import { ReactNode } from 'react';
import Redirect from 'src/features/plugins/outlook/components/Redirect';

export default function LoginLayout({ children }: { children: ReactNode }) {
  return <Redirect>{children}</Redirect>;
}
